import React, { useId } from 'react';

/** Matches admin `apps/web/src/components/CustomIcons/ContactIcon.tsx` (clipPath id made unique per instance). */
interface ContactIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
}

const ContactIcon: React.FC<ContactIconProps> = ({
  size = 20,
  color = '#404040',
  strokeWidth = 1.5,
  style,
}) => {
  const clipId = useId().replace(/:/g, '');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M3.33335 18.1812C3.8355 18.3333 4.51374 18.3333 5.66667 18.3333H14.3333C15.4863 18.3333 16.1645 18.3333 16.6666 18.1812M3.33335 18.1812C3.22569 18.1485 3.12611 18.1089 3.03169 18.0608C2.56129 17.8211 2.17884 17.4387 1.93915 16.9683C1.66667 16.4335 1.66667 15.7334 1.66667 14.3333V5.66663C1.66667 4.26649 1.66667 3.56643 1.93915 3.03165C2.17884 2.56124 2.56129 2.17879 3.03169 1.93911C3.56647 1.66663 4.26654 1.66663 5.66667 1.66663H14.3333C15.7335 1.66663 16.4335 1.66663 16.9683 1.93911C17.4387 2.17879 17.8212 2.56124 18.0609 3.03165C18.3333 3.56643 18.3333 4.26649 18.3333 5.66663V14.3333C18.3333 15.7334 18.3333 16.4335 18.0609 16.9683C17.8212 17.4387 17.4387 17.8211 16.9683 18.0608C16.8739 18.1089 16.7743 18.1485 16.6666 18.1812M3.33335 18.1812C3.33363 17.5067 3.33767 17.1498 3.39738 16.8497C3.66041 15.5274 4.69406 14.4937 6.01637 14.2307C6.33836 14.1666 6.72558 14.1666 7.5 14.1666H12.5C13.2744 14.1666 13.6616 14.1666 13.9836 14.2307C15.3059 14.4937 16.3396 15.5274 16.6026 16.8497C16.6623 17.1498 16.6664 17.5067 16.6666 18.1812M13.3333 7.91663C13.3333 9.75758 11.841 11.25 10 11.25C8.15905 11.25 6.66667 9.75758 6.66667 7.91663C6.66667 6.07568 8.15905 4.58329 10 4.58329C11.841 4.58329 13.3333 6.07568 13.3333 7.91663Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContactIcon;
